module.exports = __webpack_public_path__ + "img/icon-sb-room-of-choice-icon-100x67-v1.56d9a64.svg";